module.exports = __webpack_public_path__ + "img/10-10-3.83ccb078.jpg";